import { createAsyncAction } from 'react-redux-await-control';
import { message } from 'antd';
import { mapObject } from 'underscore';

import { handleErrors } from '~/common/utils/errorHandler';
import { normalizeNullish } from '~/hooks/useTracking';
import { oldTelli, telli } from '~/services';

export const fetchAgreements = createAsyncAction('FETCH_AGREEMENTS', {
  saveResult: true,
  initialValue: [],
  context: {
    request: (params) => telli.get('/admin/agreements', { params }),
    onRequestError: (err) => handleErrors(err, { defaultMessage: 'Não foi possível obter os convênios.' }),
    errorParser: () => [],
  },
});

export const fetchFinancialInstitutions = createAsyncAction('FETCH_FINANCIAL_INSTITUTIONS', {
  saveResult: true,
  initialValue: [],
  context: {
    errorParser: () => [],
    request: (params) => {
      const search = new URLSearchParams();
      mapObject(params, (value, key) => search.set(key, value));

      return telli.get(`/admin/financialinstitutioncustom/financialinstitutions?${search.toString()}`);
    },
  },
});

export const fetchFinancialInstitutionsForDeposit = createAsyncAction('FETCH_FINANCIAL_INSTITUTIONS_FOR_DEPOSIT', {
  saveResult: true,
  initialValue: [],
  context: {
    errorParser: () => [],
    request: (params) => telli.get(`/admin/financialinstitutioncustom/availablefordeposit`, { params }),
  },
});

export const fetchAddressFromZipCode = createAsyncAction('FETCH_ADDRESS_FROM_ZIPCODE', {
  saveResult: true,
  context: {
    onRequestError: () => message.warning('Não foi possível encontrar este CEP'),
    request: (data) => telli.post(`/openservices/addressfromzipcode`, data),
  },
});

export const getUserNotifications = createAsyncAction('GET_USER_NOTIFICATIONS', {
  saveResult: true,
  initialValue: [],
  context: {
    errorParser: () => [],
    request: () => telli.get(`/admin/notificationusers`),
  },
});

export const markNotificationsAsRead = createAsyncAction('MARK_NOTIFICATIONS_AS_READ', {
  context: {
    errorParser: () => [],
    request: ({ ids }) => telli.put(`/admin/notificationusers/markasreaded`, { ids }),
  },
});

export const fetchTicketBanks = createAsyncAction('FETCH_TICKET_BANKS', {
  saveResult: true,
  initialValue: [],
  context: {
    errorParser: () => [],
    responseParser: ({ data }) => data?.resource || [],
    onRequestError: (err) => handleErrors(err, { defaultMessage: 'Erro ao consultar bancos' }),
    request: () => telli.get('/integrations/ticket/banks'),
  },
});

export const fetchTicketFinancialInstitutions = createAsyncAction('FETCH_TICKET_FINANCIAL_INSTITUTIONS', {
  saveResult: true,
  initialValue: [],
  context: {
    errorParser: () => [],
    responseParser: ({ data }) => data?.resource || [],
    onRequestError: (err) => handleErrors(err, { defaultMessage: 'Erro ao consultar fundos' }),
    request: () => telli.get('/integrations/ticket/financial-institutions'),
  },
});

export const getParameter = createAsyncAction('GET_PARAMETER', {
  saveResult: true,
  initialValue: {},
  context: {
    errorParser: () => null,
    responseParser: ({ data }) => data?.resource,
    request: (name) => telli.get(`/admin/parameter`, { params: { name } }),
  },
});

export const sendEvent = createAsyncAction('SEND_EVENT', {
  context: {
    onRequestError: () => {},
    request: ({ tableName, event }) => {
      const eventFormatted = normalizeNullish(event);
      return oldTelli.post('/events', {
        tableName,
        dataType: 'JSON',
        databaseName: 'backoffice-log-events',
        data: [eventFormatted],
      });
    },
  },
});
